import Image from "next/image";
import { listImagesFiltered } from "@/constants/imagesUrl";
import SHeading from "@/components/atoms/SHeading";

type PhotoFilterProps = {
  className: string;
}

const PhotoFilter: React.FC<PhotoFilterProps> = ({ className }) => {
  return (

    <div className={`${className} flex flex-col items-center`}>
      <SHeading
        text="Photo Filters"
        className="text-center"
      />
      <div className="flex gap-4 mt-2 justify-center">
        {listImagesFiltered.map((item, index) => (
          <div key={index} className="relative w-[100px] h-[160px] sm:w-[125px] sm:h-[200px] overflow-hidden rounded-lg">
            <Image
              src={item.imageSrc}
              alt={item.altText}
              fill
              className="object-cover"
            />
          </div>
        ))}
      </div>
      <p className="text-xs text-center mt-2">10+ filters</p>
    </div>


  );
};

export default PhotoFilter;